import { render, staticRenderFns } from "./apply-name.vue?vue&type=template&id=cc0aff9c&scoped=true"
import script from "./apply-name.vue?vue&type=script&lang=ts"
export * from "./apply-name.vue?vue&type=script&lang=ts"
import style0 from "./apply-name.vue?vue&type=style&index=0&id=cc0aff9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0aff9c",
  null
  
)

export default component.exports